import { createFileRoute } from "@tanstack/react-router";
import AdminPhase0Documents from "@/pages/AdminPhase0Documents";
import RoleGate from "@/components/auth/RoleGate";

export const Route = createFileRoute("/admin/phase0-documents/")({
  component: () => (
    <RoleGate allow={['staff']} area="Phase 0 Documents"><AdminPhase0Documents /></RoleGate>
  ),
});
